/* HerNext — shared product gallery: thumbnails, swipe and arrow keys. Swaps photos instantly (no fade). */
(function () {
  if (customElements.get('hn-gallery')) return;
  customElements.define('hn-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.index = 0;
      this.addEventListener('click', function (e) {
        var b = e.target.closest('[data-hng-thumb]');
        if (b && self.contains(b)) self.show(+b.getAttribute('data-hng-thumb'));
      });
      this.addEventListener('keydown', function (e) {
        if (!e.target.closest('[data-hng-thumb]')) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          self.show(self.index + (e.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
      var main = this.querySelector('.hng-main');
      if (main) {
        var x0 = null, y0 = null;
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
          x0 = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) self.show(self.index + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }
    }
    count() { return this.querySelectorAll('[data-hng-slide]').length; }
    show(i, focus) {
      var n = this.count();
      if (!n) return;
      i = ((i % n) + n) % n;
      this.index = i;
      this.querySelectorAll('[data-hng-slide]').forEach(function (s) {
        var on = +s.getAttribute('data-hng-slide') === i;
        s.hidden = !on;
        if (!on) s.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (x) {} });
        else s.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      });
      this.querySelectorAll('[data-hng-thumb]').forEach(function (b) {
        var on = +b.getAttribute('data-hng-thumb') === i;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && focus) b.focus();
        if (on && b.scrollIntoView && b.parentNode.scrollWidth > b.parentNode.clientWidth) b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
      var c = this.querySelector('[data-hng-count]');
      if (c) c.textContent = (i + 1) + ' / ' + n;
    }
    select(el) {
      var s = el.closest('[data-hng-slide]');
      if (s) this.show(+s.getAttribute('data-hng-slide'));
    }
  });
  // Preload the next photos once the page is idle so switching feels instant.
  function warm() {
    document.querySelectorAll('hn-gallery .hng-slide[hidden] img[loading="lazy"]').forEach(function (img) {
      var pre = new Image();
      pre.sizes = img.sizes; pre.srcset = img.srcset; pre.src = img.src;
    });
  }
  window.addEventListener('load', function () {
    (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(warm);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var host = e.target && e.target.closest && e.target.closest('hn-gallery');
    if (host && host.select) host.select(e.target);
  });
})();
